import axios from "axios";

export const lookupOrganization = async (orgID: number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/organization?OrganizationID=${orgID}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
